module.exports = __webpack_public_path__ + "img/roadmap-2-character.502a3245.png";